import _ from 'lodash';

import * as constants from './Bookmark.constants';
import * as services from './Bookmark.service';

const state = {
  selectedCourseId: -1,

  selectedBookId: -1,

  selectedBulletId: -1,

  bookmark: [],

  res_addToFavoriteList: false,
};

const mutations = {
  [constants.SET_SELECTED_COURSE_ID](state, selectedCourseId) {
    state.selectedCourseId = selectedCourseId;
  },

  [constants.SET_SELECTED_BOOK_ID](state, selectedBookId) {
    state.selectedBookId = selectedBookId;
  },

  [constants.SET_SELECTED_BULLET_ID](state, selectedBulletId) {
    state.selectedBulletId = selectedBulletId;
  },

  [constants.GET_BOOKMARK_SUCCESS](state, bookmark) {
    if (undefined !== bookmark && null !== bookmark) {
      state.bookmark = _.map(bookmark, (video) => ({
        ...video,
        collected: true,
        isDeleted: false,
      }));
    }
  },

  [constants.UPDATE_VIDEO_IN_FAVORITE_LIST](state, payload) {
    const { bulletId } = payload.video;
    const videoIdx = _.findIndex(state.bookmark, (video) => bulletId === video.bulletId);
    let video = state.bookmark[videoIdx];
    video = {
      ...video,
      ...payload.payload,
    };
    state.bookmark.splice(videoIdx, 1, video);
  },

  [constants.ADD_VIDEO_TO_FAVORITE_LIST_SUCCESS](state, res_addToFavoriteList) {
    state.res_addToFavoriteList = res_addToFavoriteList;
  },
};

const actions = {
  async addToFavoriteList({ commit }, payload) {
    const { bulletId, toCollect } = payload;
    const res = await services.addToFavoriteList({
      bulletId,
      toCollect,
    });
    commit(constants.ADD_VIDEO_TO_FAVORITE_LIST_SUCCESS, res.data.data);
  },
};

const getters = {
  isSelectedCourse: (state) => -1 !== state.selectedCourseId,

  isSelectedBook: (state) => -1 !== state.selectedBookId,

  favoriteList: (state, getters) => {
    let favoriteList = _.filter(state.bookmark, (video) => !video.isDeleted);
    favoriteList = _.map(favoriteList, (video) => {
      let isShown = true;
      if (getters.isSelectedCourse) {
        if (getters.isSelectedBook) {
          isShown = state.selectedBookId === video.bookId;
        } else {
          isShown = state.selectedCourseId === video.courseId;
        }
      }
      return {
        ...video,
        c_isShown: isShown,
      };
    });
    return favoriteList;
  },

  readyToPlayVideos: (state, getters) => {
    let readyToPlayVideos = _.filter(getters.favoriteList, (video) => video.c_isShown);
    readyToPlayVideos = _.map(readyToPlayVideos, (video, videoIdx) => ({
      ...video,
      isLatest: readyToPlayVideos.length - 1 === videoIdx,
    }));
    return readyToPlayVideos;
  },

  selectedVideoIdx: (state, getters) => {
    return _.findIndex(
      getters.readyToPlayVideos,
      (video) => state.selectedBulletId === video.bulletId
    );
  },

  selectedVideo: (state, getters) => {
    const selectedVideo = getters.readyToPlayVideos[getters.selectedVideoIdx];
    return selectedVideo ? selectedVideo : {};
  },

  nextVideo: (state, getters) => {
    const nextVideo = getters.readyToPlayVideos[getters.selectedVideoIdx + 1];
    return nextVideo ? nextVideo : {};
  },

  favoriteTree: (state, getters) => {
    let books = _.map(state.bookmark, (video) => ({
      courseId: video.courseId,
      courseName: video.courseName,
      bookId: video.bookId,
      bookName: video.bookName,
    }));
    books = _.uniqBy(books, 'bookId');
    books = _.map(books, (book) => {
      const videos = _.filter(getters.favoriteList, (video) => book.bookId === video.bookId);
      return {
        ...book,
        c_isDeleted: 0 === videos.length,
      };
    });
    let courses = _.map(books, (book) => ({
      courseId: book.courseId,
      courseName: book.courseName,
    }));
    courses = _.uniqBy(courses, 'courseId');
    courses = _.map(courses, (course) => {
      const videos = _.filter(getters.favoriteList, (video) => course.courseId === video.courseId);
      return {
        ...course,
        books: _.filter(books, (book) => course.courseId === book.courseId),
        c_isDeleted: 0 === videos.length,
      };
    });
    courses = _.filter(
      courses,
      (course) => !course.c_isDeleted || state.selectedCourseId === course.courseId
    );
    courses = _.map(courses, (course) => ({
      ...course,
      books: _.filter(
        course.books,
        (book) => !book.c_isDeleted || state.selectedBookId === book.bookId
      ),
    }));
    return courses;
  },

  selectedCourse: (state, getters) => {
    const selectedCourse = _.find(
      getters.favoriteTree,
      (course) => state.selectedCourseId === course.courseId
    );
    return selectedCourse ? selectedCourse : {};
  },

  selectedCourseName: (state, getters) => {
    const courseName = getters.selectedCourse.courseName;
    return courseName ? courseName : '';
  },

  selectedCourseBooks: (state, getters) => {
    const books = getters.selectedCourse.books;
    return books ? books : [];
  },

  selectedBook: (state, getters) => {
    const selectedBook = _.find(
      getters.selectedCourseBooks,
      (book) => state.selectedBookId === book.bookId
    );
    return selectedBook ? selectedBook : {};
  },

  selectedBookName: (state, getters) => {
    const bookName = getters.selectedBook.bookName;
    return bookName ? bookName : '';
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
